import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { Lock, ArrowLeft, PaperclipIcon } from "lucide-react";
import Loading from "../../../component/Loading/Loading";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import AlertMsg from '../../../component/AlertMsg/AlertMsg';
import useAxiosInstance from "../../../services/useAxiosInstance";

const EditContract = () => {
  const userId = useSelector((state) => state.auth.userId);
  const [alert, setAlert] = useState({ visible: false, message: "", type: "" });
  const axiosInstance = useAxiosInstance();
  const { id } = useParams();
  const history = useHistory();
  const employeeId = useSelector((state) => state.auth.employeeId);
  const currentDate = new Date();
  const formattedDates = currentDate.toISOString();
  const [planData, setPlanData] = useState({});
  const [countryData, setCountryData] = useState([]);
  const [stateData, setStateData] = useState([]);
  const [someData, setSomeData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [formErrors, setFormErrors] = useState({});

  const [formData, setFormData] = useState({
    addressDto: {
      activestatus: true,
      address: "",
      addressId: 0,
      city: "",
      countryId: 0,
      stateId: 0,
      zipCode: 0
    },
    clientRequest: {
      boardMemberRole: "",
      addressDto: {
        activestatus: true,
        address: "",
        addressId: 0,
        city: "",
        countryId: 0,
        stateId: 0,
        zipCode: 0,
      },
      clientDto: {
        activestatus: true,
        clientid: 0,
        communityid: null,
        displayname: " ",
        numberofhouses: 0,
        userid: 0,
      },
      contractCode: "",
      userDto: {
        activeStatus: false,
        emailId: "",
        userId: 0,
        createdDate: "",
        emailIdIsVerified: true,
        firstName: "",
        isClient: false,
        lastLogin: formattedDates,
        lastName: "",
        middleName: "",
        mobileIsVerified: true,
        mobileNumber: "",
        modifiedById: userId,
        modifiedDate: formattedDates,
        otp: 0,
        password: "",
        roleId: 0,
      },
    },
    contractDto: {
      annualrenewalfee: planData.price,
      buisnessname: "",
      businessaddressid: null,
      clientid: 0,
      communicationchannel: "",
      contractcode: "",
      contractid: 0,
      createdbyid: 0,
      createddate: "",
      istermsaccepted: true,
      modifiedbyid: 0,
      modifieddate: "",
      onetimesetup: 0,
      planid: planData.planId,
      renewalcycles: planData.planPeriod,
      salespersonid: employeeId,
      sizeofthecommunity: planData.planRange,
    },
  });

  const [selectedCountryId, setSelectedCountryId] = useState("");
  const [selectedCommunityCountryId, setSelectedCommunityCountryId] = useState("");

  const [planFormData, setPlanFormData] = useState({
    planPeriod: "",
    planRange: "",
    planType: "",
  });
  const [planPeriods, setPlanPeriods] = useState([]);
  const [planRangeData, setPlanRangeData] = useState([]);
  const [planTypeData, setPlanTypeData] = useState([]);

  useEffect(() => {
    axiosInstance
      .get(`/api/public/country/getAll`)
      .then((response) => {
        setCountryData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching countries:", error);
      });
  }, []);

  useEffect(() => {
    axiosInstance
      .get(`/api/public/state/getAll`)
      .then((response) => {
        setStateData(response.data);
      })
      .catch((error) => {
        console.error("Error fetching states:", error);
      });
  }, []);

  const handleChange = (e) => {
    const { name, value } = e.target;
    const [section, ...nestedProperties] = name.split(".");

    let sanitizedValue = value;
    if (name === "clientRequest.userDto.mobileNumber") {
      sanitizedValue = value.replace(/[^0-9]/g, '');
    }

    if (name === "addressDto.countryId") {
      setSelectedCommunityCountryId(sanitizedValue);
    }
    if (name === "clientRequest.addressDto.countryId") {
      setSelectedCountryId(sanitizedValue);
    }

    const updateNestedProperty = (obj, props, val) => {
      if (props.length === 0) {
        if (
          name === "addressDto.countryId" ||
          name === "addressDto.stateId" ||
          name === "clientRequest.addressDto.countryId" ||
          name === "clientRequest.addressDto.stateId"
        ) {
          return parseInt(val, 10);
        }
        return val;
      }

      const [currentProp, ...remainingProps] = props;
      return {
        ...obj,
        [currentProp]: updateNestedProperty(
          obj[currentProp],
          remainingProps,
          val
        ),
      };
    };

    setFormData((prevState) => {
      if (section === "addressDto" || section === "contractDto") {
        return {
          ...prevState,
          [section]: updateNestedProperty(
            prevState[section],
            nestedProperties,
            sanitizedValue
          ),
        };
      } else if (section === "clientRequest") {
        return {
          ...prevState,
          clientRequest: {
            ...prevState.clientRequest,
            [nestedProperties[0]]: updateNestedProperty(
              prevState.clientRequest[nestedProperties[0]],
              nestedProperties.slice(1),
              sanitizedValue
            ),
          },
        };
      } else {
        throw new Error(`Unsupported section: ${section}`);
      }
    });
  };

  const handlePhoneNumberChange = (value) => {
    const sanitizedValue = value.replace(/[^0-9]/g, '');

    setFormData((prevFormData) => ({
      ...prevFormData,
      clientRequest: {
        ...prevFormData.clientRequest,
        userDto: {
          ...prevFormData.clientRequest.userDto,
          mobileNumber: sanitizedValue,
        },
      },
    }));

    setFormErrors((prevErrors) => ({
      ...prevErrors,
      mobileNumber: sanitizedValue.length === 10 ? "" : "Phone Number must be exactly 10 digits",
    }));
  };

  const validateForm = () => {
    let errors = {};

    if (!formData.clientRequest.userDto.firstName) {
      errors.firstName = "First Name is required";
    } else if (formData.clientRequest.userDto.firstName.length > 20) {
      errors.firstName = "First Name must be less than 20 characters";
    }

    if (!formData.clientRequest.userDto.lastName) {
      errors.lastName = "Last Name is required";
    } else if (formData.clientRequest.userDto.lastName.length > 20) {
      errors.lastName = "Last Name must be less than 20 characters";
    }

    if (!formData.clientRequest.userDto.emailId) {
      errors.emailId = "Email Address is required";
    } else if (!validateEmail(formData.clientRequest.userDto.emailId)) {
      errors.emailId = "Invalid email address";
    }

    if (!formData.clientRequest.userDto.mobileNumber.trim()) {
      errors.mobileNumber = 'Phone Number is required';
    } else if (formData.clientRequest.userDto.mobileNumber.length < 10) {
      errors.mobileNumber = 'Phone Number must be exactly 10 digits';
    }

    if (!formData.clientRequest.addressDto.address) {
      errors.ClientAddress = "Address is required";
    } else if (formData.clientRequest.addressDto.address.length > 100) {
      errors.ClientAddress = "Address must be less than 100 characters";
    }

    if (!formData.clientRequest.addressDto.stateId) {
      errors.ClientStateId = "State is required";
    }

    if (!formData.clientRequest.addressDto.countryId) {
      errors.ClientCountryId = "Country is required";
    }

    if (!formData.clientRequest.addressDto.zipCode) {
      errors.ClientZipCode = "Zip Code is required";
    }

    if (!formData.clientRequest.addressDto.city) {
      errors.ClientCity = "City is required";
    }

    if (!formData.contractDto.buisnessname) {
      errors.buisnessname = "Business Name is required";
    } else if (formData.contractDto.buisnessname.length > 20) {
      errors.buisnessname = "Business Name must be less than 100 characters";
    }

    if (!formData.addressDto.address) {
      errors.address = "Address is required";
    } else if (formData.addressDto.address.length > 100) {
      errors.address = "Address must be less than 100 characters";
    }

    if (!formData.addressDto.stateId) {
      errors.stateId = "State is required";
    }

    if (!formData.addressDto.countryId) {
      errors.countryId = "Country is required";
    }

    if (!formData.addressDto.zipCode) {
      errors.zipCode = "Zip Code is required";
    }

    if (!formData.addressDto.city) {
      errors.city = "City is required";
    }

    if (!formData.contractDto.communicationchannel) {
      errors.communicationchannel = "Communication channel is required";
    } else if (formData.contractDto.communicationchannel.length > 20) {
      errors.communicationchannel =
        "Communication channel must be less than 20 characters";
    }

    if (!planFormData.planRange) {
      errors.planRange = "Plan Range is required";
    } else if (planFormData.planRange.length > 20) {
      errors.planRange = "Plan Range must be less than 20 characters";
    }

    if (!planFormData.planType) {
      errors.planType = "Plan Type is required";
    } else if (planFormData.planType.length > 20) {
      errors.planType = "Plan Type must be less than 20 characters";
    }

    if (!planFormData.planPeriod) {
      errors.planPeriod = "Plan Period is required";
    } else if (planFormData.planPeriod.length > 20) {
      errors.planPeriod = "Plan Period must be less than 20 characters";
    }

    if (!formData.contractDto.onetimesetup) {
      errors.onetimesetup = "One Time Setup is required";
    } else if (formData.contractDto.onetimesetup.length > 6) {
      errors.onetimesetup = "One Time Setup must be less than 20 characters";
    }

    return errors;
  };

  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await axiosInstance.get(
          `/api/public/contract/getContractUpdateResponse/${id}`
        );
        const data = response.data;
        setSomeData(data);
        const formDataUpdate = {
          addressDto: {
            activestatus: data.businessAddressActiveStatus,
            address: data.businessAddress,
            addressId: data.businessAddressId,
            city: data.businessAddressCity,
            countryId: data.businessAddressCountryId,
            stateId: data.businessAddressStateId,
            zipCode: data.businessAddressZipCode,
          },
          clientRequest: {
            addressDto: {
              activestatus: data.clientAddressActiveStatus,
              address: data.clientAddress,
              addressId: data.clientAddressId,
              city: data.clientAddressCity,
              countryId: data.clientAddressCountryId,
              stateId: data.clientAddressStateId,
              zipCode: data.clientAddressZipCode,
            },
            boardMemberRole: " ",
            clientDto: {
              activestatus: data.clientActiveStatus,
              clientid: data.clientId,
              communityid: data.communityId,
              displayname: data.displayName,
              numberofhouses: data.numberOfHouses,
              userid: data.userId,
            },
            contractCode: " ",
            userDto: {
              activeStatus: data.userActiveStatus,
              emailId: data.emailId,
              userId: data.userId,
              emailIdIsVerified: data.emailIdIsVerified,
              firstName: data.firstName,
              isClient: data.isClient,
              lastLogin: data.lastLogin,
              lastName: data.lastName,
              middleName: data.middleName,
              mobileIsVerified: data.mobileIsVerified,
              mobileNumber: data.mobileNumber,
              otp: data.otp,
              password: data.password,
              roleId: data.roleId,
            },
          },
          contractDto: {
            annualrenewalfee: data.annualRenewalFee,
            buisnessname: data.businessName,
            businessaddressid: data.businessAddressId,
            clientid: data.clientId,
            communicationchannel: data.communicationChannel,
            contractcode: data.contractCode,
            contractid: data.contractId,
            createdbyid: data.createdById,
            createddate: data.createdDate,
            istermsaccepted: data.isTermsAccepted,
            modifiedbyid: data.modifiedbyid,
            modifieddate: data.modifiedDate == null ? '' : data.modifiedDate,
            onetimesetup: data.oneTimeSetUp,
            planid: data.planId,
            renewalcycles: data.renewalCycles,
            salespersonid: data.salesPersonId,
            salesPersonName: data.salesPersonName,
            sizeofthecommunity: data.sizeOfTheCommunity
          },
        };
        setSelectedCountryId(data.clientAddressCountryId);
        setSelectedCommunityCountryId(data.businessAddressCountryId);

        setFormData(formDataUpdate);
        setPlanFormData({
          planPeriod: data.planPeriodId,
          planRange: data.planRange,
          planType: data.planTypeId,
        });
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    if (id) {
      fetchData();
    }
  }, [id]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    const currentDate = new Date();
    const formattedDate = currentDate.toISOString();

    const updatedFormData = {
      ...formData,
      contractDto: {
        ...formData.contractDto,
        modifiedbyid: userId,
        modifieddate: formattedDate,
      },
    };

    const errors = validateForm();
    if (Object.keys(errors).length === 0) {
      try {
        const response = await axiosInstance.put(
          `/api/public/contract/updateContract/${id}`,
          updatedFormData
        );
        const responseData = response.data;
        setAlert({ visible: true, message: 'Contract updated successfully!', type: 'success' });
        setLoading(false);
        setTimeout(() => {
          history.goBack();
        }, 2500);
      } catch (error) {
        setAlert({ visible: true, message: 'Error updating contract: Please try again.', type: 'error' });
        console.error("Error:", error);
        setLoading(false);
      }
    } else {
      setFormErrors(errors);
      setLoading(false);
      setAlert({ visible: true, message: 'Error updating contract: Please fix the highlighted fields.', type: 'error' });
    }
  };

  const handleCancel = () => {
    setFormErrors({});
    history.goBack();
  };

  useEffect(() => {
    const fetchPlanPeriods = async () => {
      try {
        const response = await axiosInstance.get(`/api/public/plan-period/all`);
        setPlanPeriods(response.data);
      } catch (error) {
        console.error("Error fetching plan period data:", error);
      }
    };

    const fetchPlanRanges = async () => {
      try {
        const response = await axiosInstance.get(`/api/public/plan-range/all`);
        setPlanRangeData(response.data);
      } catch (error) {
        console.error("Error fetching plan range data:", error);
      }
    };

    const fetchPlanTypes = async () => {
      try {
        const response = await axiosInstance.get(`/api/public/plan-type/all`);
        setPlanTypeData(response.data);
      } catch (error) {
        console.error("Error fetching plan type data:", error);
      }
    };

    fetchPlanPeriods();
    fetchPlanRanges();
    fetchPlanTypes();
  }, []);

  useEffect(() => {
    if (
      planFormData.planPeriod &&
      planFormData.planRange &&
      planFormData.planType
    ) {
      handleFind();
    }
  }, [planFormData]);

  const handlePlanChange = (e) => {
    const { name, value } = e.target;
    setPlanFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleFind = async () => {
    const { planPeriod, planRange, planType } = planFormData;

    if (planPeriod && planRange && planType) {
      const url = `/api/public/plan/find/${planType}/${planRange}/${planPeriod}`;
      try {
        const response = await axiosInstance.get(url);
        setPlanData(response.data);
      } catch (error) {
        console.error("Error fetching plan data:", error.response ? error.response.data : error.message);
      }
    } else {
      console.error("One or more of the plan data parameters are undefined.");
    }
  };

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractDto: {
        ...prevFormData.contractDto,
        annualrenewalfee: planData.price,
        planid: planData.planId,
      },
    }));
  }, [planData.price, planData.planId, planData.planRange]);

  useEffect(() => {
    setFormData((prevFormData) => ({
      ...prevFormData,
      contractDto: {
        ...prevFormData.contractDto,
        renewalcycles: planData.planPeriod
          ? planData.planPeriod.planPeriod
          : "",
        sizeofthecommunity: planData.planRange
          ? parseCommunitySize(planData.planRange.planRange)
          : "",
      },
    }));
  }, [planData.planPeriod, planData.planRange]);

  const parseCommunitySize = (rangeString) => {
    const parts = rangeString.split("-");
    const sizeOfCommunity = parseInt(parts[1]);
    return sizeOfCommunity;
  };

  const validateEmail = (email) => {
    const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
    return emailRegex.test(email);
  };

  return (
    <div className="bg-gray-50 min-h-screen md:p-4">
      {loading && <Loading />}
      {!loading && (
        <div className="max-w-7xl mx-auto">
          {alert.visible && (
            <AlertMsg
              message={alert.message}
              type={alert.type}
              onClose={() => setAlert({ ...alert, visible: false })}
            />
          )}

          <div className="flex justify-between items-center mb-6">
            <h1 className="text-2xl font-bold text-gray-800">Edit Contract</h1>
            <div className="flex space-x-3">
              <button className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2">
                <PaperclipIcon size={18} />
                <span>Save as Draft</span>
              </button>
            </div>
          </div>

          <form onSubmit={handleSubmit}>
            {/* Contract Form Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4 flex justify-between items-center">
                <h2 className="text-xl font-semibold text-gray-800">Contract Form filled by sales team</h2>
                <Link to="/contract-list" className="bg-blue-500 hover:bg-blue-600 text-white px-4 py-2 rounded-md flex items-center gap-2">
                  <ArrowLeft size={18} />
                  <span>Back</span>
                </Link>
              </div>

              <div className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Sales Agent Name</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="salesAgestName"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={formData.contractDto.salesPersonName}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Contract Details Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">Contract Details</h2>
              </div>

              <div className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Date Created</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="createddate"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={formData.contractDto.createddate}
                        readOnly
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Created By</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="createdByName"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={someData.createdByName}
                        readOnly
                        onChange={handleChange}
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Last Updated</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="modifieddate"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={formData.contractDto.modifieddate}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Last Updated by</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="modifiedByName"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={someData.modifiedByName}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">Contract Code</label>
                    <div className="relative">
                      <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Lock className="h-4 w-4 text-gray-500" />
                      </div>
                      <input
                        type="text"
                        name="contractCode"
                        className="w-full rounded-md border border-gray-300 pl-10 py-2 px-3 bg-gray-50 text-gray-700"
                        value={formData.contractDto.contractcode}
                        onChange={handleChange}
                        readOnly
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Client Details Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">Client Details</h2>
              </div>

              <div className="p-6 space-y-6">
                {/* First row - Name fields */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      First Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.firstName"
                      value={formData.clientRequest.userDto.firstName}
                      onChange={handleChange}
                      maxLength="20"
                      className={`w-full rounded-md border ${formErrors.firstName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.firstName && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.firstName}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Middle Name
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.middleName"
                      value={formData.clientRequest.userDto.middleName}
                      onChange={handleChange}
                      maxLength="20"
                      className="w-full rounded-md border border-gray-300 px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500"
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Last Name <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.lastName"
                      value={formData.clientRequest.userDto.lastName}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.lastName ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.lastName && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.lastName}</p>
                    )}
                  </div>
                </div>

                {/* Second row - Contact Information */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6 w-full">
                  <div className="w-full md:min-w-1/2 ">
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Mobile Number <span className="text-red-500">*</span>
                    </label>
                    <PhoneInput
                      inputProps={{
                        name: "clientRequest.userDto.mobileNumber",
                        required: true,
                        autoFocus: true,
                        placeholder: "Enter mobile number",
                        style: { padding: '20px 35px', width: '100%' },
                      }}
                      value={formData.clientRequest.userDto.mobileNumber}
                      onChange={handlePhoneNumberChange}
                      country={"us"}
                      containerClass="phone-input-container"
                      inputClass={`min-w-full md:min-w-full rounded-md border  focus:outline-none focus:ring-2 focus:ring-blue-500 ${formErrors.mobileNumber ? 'border-red-500' : 'border-gray-300'}`}
                      buttonStyle={{ border: "none", background: "transparent" }}
                    />

                    {formErrors.mobileNumber && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.mobileNumber}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Email Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="clientRequest.userDto.emailId"
                      value={formData.clientRequest.userDto.emailId}
                      onChange={handleChange}
                      maxLength="50"
                      className={`w-full rounded-md border ${formErrors.emailId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.emailId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.emailId}</p>
                    )}
                  </div>
                </div>

                {/* Client Address */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Address <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="clientRequest.addressDto.address"
                    value={formData.clientRequest.addressDto.address}
                    onChange={handleChange}
                    maxLength="100"
                    className={`w-full rounded-md border ${formErrors.ClientAddress ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.ClientAddress && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.ClientAddress}</p>
                  )}
                </div>

                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    City <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="clientRequest.addressDto.city"
                    value={formData.clientRequest.addressDto.city}
                    onChange={handleChange}
                    maxLength="50"
                    className={`w-full rounded-md border ${formErrors.ClientCity ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.ClientCity && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.ClientCity}</p>
                  )}
                </div>

                {/* Location fields */}
                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Country <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="clientRequest.addressDto.countryId"
                      value={formData.clientRequest.addressDto.countryId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientCountryId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Country</option>
                      {countryData.map((country) => (
                        <option key={country.countryid} value={country.countryid}>
                          {country.countryname}
                        </option>
                      ))}
                    </select>
                    {formErrors.ClientCountryId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientCountryId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      State <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="clientRequest.addressDto.stateId"
                      value={formData.clientRequest.addressDto.stateId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientStateId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="0">Select State</option>
                      {stateData
                        .filter(
                          (state) =>
                            state.country?.countryid ===
                            parseInt(selectedCountryId)
                        )
                        .map((state) => (
                          <option key={state.stateid} value={state.stateid}>
                            {state.statename}
                          </option>
                        ))}
                    </select>
                    {formErrors.ClientStateId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientStateId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Zip Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      name="clientRequest.addressDto.zipCode"
                      value={formData.clientRequest.addressDto.zipCode}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.ClientZipCode ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.ClientZipCode && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.ClientZipCode}</p>
                    )}
                  </div>
                </div>

                {/* Business Name */}
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Business Name <span className="text-red-500">*</span>
                  </label>
                  <input
                    type="text"
                    name="contractDto.buisnessname"
                    value={formData.contractDto.buisnessname}
                    onChange={handleChange}
                    maxLength="20"
                    className={`w-full rounded-md border ${formErrors.buisnessname ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                  />
                  {formErrors.buisnessname && (
                    <p className="text-red-500 text-xs mt-1">{formErrors.buisnessname}</p>
                  )}
                </div>

                {/* Business Address */}
                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Business Address <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="addressDto.address"
                      value={formData.addressDto.address}
                      onChange={handleChange}
                      maxLength="100"
                      className={`w-full rounded-md border ${formErrors.address ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.address && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.address}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      City <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="addressDto.city"
                      value={formData.addressDto.city}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.city ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.city && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.city}</p>
                    )}
                  </div>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Country <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="addressDto.countryId"
                      value={formData.addressDto.countryId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.countryId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Country</option>
                      {countryData.map((country) => (
                        <option key={country.countryid} value={country.countryid}>
                          {country.countryname}
                        </option>
                      ))}
                    </select>
                    {formErrors.countryId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.countryId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      State <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="addressDto.stateId"
                      value={formData.addressDto.stateId}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.stateId ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select State</option>
                      {stateData
                        .filter(
                          (state) =>
                            state.countryid ===
                            parseInt(selectedCommunityCountryId)
                        )
                        .map((state) => (
                          <option key={state.stateid} value={state.stateid}>
                            {state.statename}
                          </option>
                        ))}
                    </select>
                    {formErrors.stateId && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.stateId}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Zip Code <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="number"
                      name="addressDto.zipCode"
                      value={formData.addressDto.zipCode}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.zipCode ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.zipCode && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.zipCode}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Preferred Communication Channel <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="contractDto.communicationchannel"
                      value={formData.contractDto.communicationchannel}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.communicationchannel ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select</option>
                      <option value="Email">Email</option>
                      <option value="Phone (sms)">Phone (sms)</option>
                      <option value="Phone (Call)">Phone (Call)</option>
                      <option value="Mail">Mail</option>
                    </select>
                    {formErrors.communicationchannel && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.communicationchannel}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Plan Details Section */}
            <div className="bg-white rounded-lg shadow-sm overflow-hidden mb-6">
              <div className="border-b px-6 py-4">
                <h2 className="text-xl font-semibold text-gray-800">Plan Details</h2>
              </div>

              <div className="p-6 space-y-6">
                <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Size of the Community <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planRange"
                      value={planFormData.planRange}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planRange ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Range</option>
                      {planRangeData.map((range) => (
                        <option key={range.id} value={range.id}>
                          {range.planRange}
                        </option>
                      ))}
                    </select>
                    {formErrors.planRange && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planRange}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Plan Type <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planType"
                      value={planFormData.planType}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planType ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Type</option>
                      {planTypeData.map((type) => (
                        <option key={type.id} value={type.id}>
                          {type.planType}
                        </option>
                      ))}
                    </select>
                    {formErrors.planType && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planType}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Renewal Cycles <span className="text-red-500">*</span>
                    </label>
                    <select
                      name="planPeriod"
                      value={planFormData.planPeriod}
                      onChange={handlePlanChange}
                      className={`w-full rounded-md border ${formErrors.planPeriod ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    >
                      <option value="">Select Plan Period</option>
                      {planPeriods.map((period) => (
                        <option key={period.id} value={period.id}>
                          {period.planPeriod}
                        </option>
                      ))}
                    </select>
                    {formErrors.planPeriod && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.planPeriod}</p>
                    )}
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      Plan Price
                    </label>
                    <input
                      type="text"
                      name="planData.price"
                      value={planData.price}
                      onChange={handleChange}
                      className="w-full rounded-md border border-gray-300 px-4 py-2 bg-gray-50 text-gray-700"
                      readOnly
                    />
                  </div>

                  <div>
                    <label className="block text-sm font-medium text-gray-700 mb-1">
                      One Time Setup <span className="text-red-500">*</span>
                    </label>
                    <input
                      type="text"
                      name="contractDto.onetimesetup"
                      value={formData.contractDto.onetimesetup}
                      onChange={handleChange}
                      className={`w-full rounded-md border ${formErrors.onetimesetup ? "border-red-500" : "border-gray-300"} px-4 py-2 focus:outline-none focus:ring-2 focus:ring-blue-500`}
                    />
                    {formErrors.onetimesetup && (
                      <p className="text-red-500 text-xs mt-1">{formErrors.onetimesetup}</p>
                    )}
                  </div>
                </div>
              </div>
            </div>

            {/* Form Actions */}
            <div className="flex justify-between items-center mb-6">
              <div className="text-sm text-red-500">
                * Required fields
              </div>
              <div className="flex space-x-4">
                <button
                  type="button"
                  onClick={handleCancel}
                  className="px-6 py-2 border border-gray-300 rounded-md text-gray-700 hover:bg-gray-50"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="px-6 py-2 bg-blue-500 text-white rounded-md hover:bg-blue-600"
                >
                  Submit
                </button>
              </div>
            </div>
          </form>
        </div>
      )}
    </div>
  );
};

export default EditContract;